<button class="exit">
  <img (click)="closeDialog()" src="../../../assets/icons/white-cancel.svg">
</button>
<div class="dialog-container container">
  <div [ngStyle]="{'background-image':'url('+ data.imageUrl+')'}"
       class="image-block">
  </div>
</div>
